export const FALLBACK_PERIODS = ['Team', '1', '2', '3', '4']
